import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import AnimatedGridPattern from "../../userJourneyComponent/AnimatedGridPattern";

const SectionContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(12),
  backgroundColor: "#ffffff",
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
}));

const GridBackground = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  overflow: "hidden",
}));

const ContentWrapper = styled(Box)({
  position: "relative",
  zIndex: 1,
});

const HeroHeadline = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginBottom: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(2.5),
  },
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontSize: "3.5rem",
  fontWeight: 700,
  lineHeight: 1.2,
  color: "#1D47A4",
  letterSpacing: "-0.02em",
  [theme.breakpoints.down("lg")]: {
    fontSize: "3rem",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const HeroSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 600,
  color: "#3567D6",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.75rem",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "1.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.25rem",
  },
}));

const HeroDescription = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  color: "#4C4C4C",
  lineHeight: 1.7,
  maxWidth: "750px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    fontSize: "1rem",
  },
}));

const HeroSection = () => {
  return (
    <SectionContainer>
      {/* Animated Grid Background */}
      <GridBackground>
        <AnimatedGridPattern
          numSquares={40}
          maxOpacity={0.12}
          duration={4}
          repeatDelay={0.5}
          width={40}
          height={40}
          sx={{
            fill: "rgba(53, 103, 214, 0.04)",
            stroke: "rgba(53, 103, 214, 0.08)",
          }}
        />
      </GridBackground>

      <Container>
        <ContentWrapper>
          {/* Hero Headline */}
          <HeroHeadline>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <HeroTitle>
                Turn Every Lab Report Into
                <br />
                a Meaningful Conversation
              </HeroTitle>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <HeroSubtitle>
                AI-Powered Engagement Tools That Patients Actually Use
              </HeroSubtitle>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <HeroDescription>
                Bridge the gap between labs, doctors, and patients with intelligent tools that
                simplify medical data and drive continuous engagement.
              </HeroDescription>
            </motion.div>
          </HeroHeadline>
        </ContentWrapper>
      </Container>
    </SectionContainer>
  );
};

export default HeroSection;
